import { createIcon } from './icon';

export const BellIcon = createIcon(
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M8 1.5C5.79 1.5 4 3.29 4 5.5V7c0 1.5-.5 3-1.5 4h11c-1-1-1.5-2.5-1.5-4V5.5c0-2.21-1.79-4-4-4z" />
    <path d="M6.5 13a1.5 1.5 0 003 0" />
  </svg>,
  'BellIcon'
);
